export default "__VITE_ASSET__8e048eb7__"